import moment from 'moment';

import { featureToggleInit } from '@guestyci/feature-toggle-fe';
import Resource from '@guestyci/agni';

import { getHostName } from 'utils/common';
import { getOwnersPortalMeta } from 'ui/ui.services';
import jwt from 'utils/jwt';
import localStorage from 'utils/localStorage';

const getAccountId = async () => {
  const { accountId } = jwt.decode(localStorage.getAuthToken());
  if (accountId) {
    return accountId;
  }

  const response = await getOwnersPortalMeta(getHostName());
  return response.accountId;
};

export const initFeatureToggle = async () => {
  try {
    const { accountId } = Resource.getCurrentUser();

    window.featureToggle = await featureToggleInit({
      env: process.env.REACT_APP_CLUSTER,
      accountId: accountId || (await getAccountId()),
    });
  } catch (err) {
    console.error(err);
  }
};

export const initMoment = (locale) => {
  moment.defineLocale('en-US-nonAmericanDates', {
    parentLocale: 'en-US',
  });
  moment.updateLocale('en-US-nonAmericanDates', {
    longDateFormat: {
      L: 'DD/MM/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A',
      LT: 'h:mm A',
      LTS: 'h:mm:ss A',
    },
  });

  moment.locale(locale);
};
